import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {FieldConfig} from "@biletix/core/models/base/field-config.model";

@Component({
  selector: 'btx-input',
  templateUrl:'./btx-input.component.html',
  styleUrls: ['./btx-input.component.scss'],
  standalone: false
})
export class BtxInputComponent implements OnInit {

  @Input()
  field: FieldConfig | any;

  @Input()
  group: FormGroup | any;


  constructor() {
  }

  ngOnInit(): void {
  }


}
